module.exports = __webpack_public_path__ + "img/tabyoureit.55e961e9.png";